import { z } from "zod";

// --- Entity schemas (API) ---
export const userProfileSchema = z.object({
  publicId: z.string(),
  email: z.string(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  profilePictureKey: z.string().nullable(),
  role: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type UserProfile = z.infer<typeof userProfileSchema>;

export const userConfigSchema = z.object({
  publicId: z.string(),
  theme: z.string(),
  language: z.string(),
  preferences: z.record(z.string(), z.unknown()),
  updatedAt: z.string(),
});

export type UserConfig = z.infer<typeof userConfigSchema>;
